import React, { useMemo } from 'react';

import { ISTOSuratPesananMappedData } from './interfaces';
import { STOSuratPesananOOTPrekursorPrintTemplateComponent } from './STOSuratPesananOOTPrekursorPrintTemplate.component';
import { STOSuratPesananPrintTemplateComponent } from './STOSuratPesananPrintTemplate.component';

export const STOSuratPesananPrintTemplate: React.FC = () => {
  document.body.className = 'print-template';

  const data: ISTOSuratPesananMappedData | null = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('sto-surat-pesanan') || 'null');
    } catch {
      return null;
    }
  }, []);

  if (!data) {
    return <div>Data is not loaded</div>;
  }
  return data.is_oot || data.is_prekursor ? (
    <STOSuratPesananOOTPrekursorPrintTemplateComponent data={data} />
  ) : (
    <STOSuratPesananPrintTemplateComponent data={data} />
  );
};
